import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import { Title, PageHeader, LoadingCard } from '../Shared';
import { leaderboardActions } from '../_actions';
import classnames from 'classnames';
import calendar from '../Locations/calendar.png';
import { date } from '../_helpers';
import clock from '../Locations/clock.png';

const LeaderBoardPane = (props) => {
  return (
    <Container>
      {!isEmpty(props.data) ? (
        <>
          {props.data.map((res, idx) => (
            <Row key={idx} style={{ paddingTop: 5 }}>
              <Col
                style={{
                  backgroundColor: '#F2F2F2',
                  width: '100%',
                  height: 30,
                  borderRadius: 20,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <small style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>
                    {res.location.name}
                  </small>
                </div>
                <div></div>
                <div>
                  <img src={calendar} alt="calendar" />
                  <small className="pl-1" style={{ fontSize: '0.65rem' }}>
                    {date.getShortDate(res.timeStarted)}
                  </small>
                  <img src={clock} className="pl-2" alt="clock" />
                  <small className="pl-1" style={{ fontSize: '0.65rem' }}>
                    {res.tsDuration}
                  </small>
                </div>
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <div className="no-times text-center">No times recorded</div>
      )}
    </Container>
  );
};

function MyResults(props) {
  const { getMyResults, myResults, loading } = props;
  const [infoTab, setInfoTab] = useState('casual');

  useEffect(() => {
    getMyResults();
  }, [getMyResults]);

  return (
    <Fragment>
      <Title text="My Results" />
      <PageHeader>
        <Row>
          <Col>
            <h2 className="text-center orange-title">My Results</h2>
          </Col>
        </Row>
      </PageHeader>
      <Container className="mt-2 pl-4 pr-4">
        <Row>
          {loading && <LoadingCard />}
          {!isEmpty(myResults) && (
            <Fragment>
              <Col
                xs={12}
                className="text-center"
                style={{ lineHeight: '1rem' }}
              >
                <small style={{ fontWeight: 'bold' }}>
                  You have completed {myResults.count} Park Warrior Courses,
                  with {myResults.totalOfficial} results on the Competition
                  Leaderboard and {myResults.totalUnofficial} on the Social
                  Leaderboard.
                </small>
                <br />
                <br />
                <small style={{ fontWeight: 'bold', color: '#ff461f' }}>
                  You are {myResults.diffPercent}{' '}
                  {myResults.faster ? `faster` : `slower`} than the average
                  across all Locations. Your average course completion time is{' '}
                  {myResults.time}.
                </small>
              </Col>
              <Col xs={12}>
                <hr />
              </Col>
            </Fragment>
          )}
        </Row>
      </Container>

      {!isEmpty(myResults) && (
        <Container
          className="mt-2 pb-4 pl-4 pr-4"
          style={{ backgroundColor: '#fff' }}
        >
          <Nav className="rounded-tabs" fill tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: infoTab === 'casual' })}
                onClick={() => setInfoTab('casual')}
              >
                CASUAL TIMES
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: infoTab === 'event' })}
                onClick={() => setInfoTab('event')}
              >
                COMPETITION TIMES
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={infoTab}>
            <TabPane tabId="casual">
              <LeaderBoardPane data={myResults.unofficial} />
            </TabPane>
            <TabPane tabId="event">
              <LeaderBoardPane data={myResults.official} />
            </TabPane>
          </TabContent>
        </Container>
      )}
    </Fragment>
  );
}
const mapDispatch = {
  getMyResults: leaderboardActions.myResults,
};

function mapState(state) {
  const { myResults, loading } = state.leaderboard;
  return { myResults, loading };
}

const connectedMyResults = connect(mapState, mapDispatch)(MyResults);
export { connectedMyResults as MyResults };
